import { CommonHelper } from './../../shared/helpers/CommonHelper';
import { Component, OnInit } from '@angular/core';
import { Search } from './../../models/Search.model';
import { ProjectFinancialService } from './../../services/projectFinancial.service';
import { ResponsibleFinancial } from './../../models/project/ResponsibleFinancial.model';
import { CompanyFinancial } from './../../models/project/CompanyFinancial.model';
import { ProjectFinancial } from './../../models/project/ProjectFinancial.model';
import { Json2csvService } from "../../services/json2csv.service";
import { Consultant } from '../../models/Consultant.model';
import { DropDownList } from '../../models/DropDownList.model';
import { LocalStorage } from '../../shared/wrappers/LocalStorage';
import { CompanyService } from "./../../services/billing-letter/company.service"
import { ExcellenceCentersService } from '../../services/excellenceCenters.service';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {
    loading: boolean;
    projects: ProjectFinancial[] = new Array<ProjectFinancial>();
    companies: CompanyFinancial[] = new Array<CompanyFinancial>();
    responsibles: ResponsibleFinancial[] = new Array<ResponsibleFinancial>();
    consultants: Consultant[] = new Array<Consultant>();
    projectsShow: ProjectFinancial[] = new Array<ProjectFinancial>();
    excellenceCenters = new Array();
    divisions = new Array();
    findResults: Search = new Search();
    listProjects: Array<String> = new Array<String>();

    objCompanies: any;
    objResponsables: any;
    objProjecthash: any;
    projectsSearch: any;

    objConsultant: any;

    dropDownListExcellenceCenters: any;
    selectedExcellenceCentersItems: DropDownList[] = new Array<DropDownList>();
    dropDownExcellenceCentersSettings = {}

    commonHelper: CommonHelper = new CommonHelper();

    project: ProjectFinancial = new ProjectFinancial();
    consultantsLoad: Consultant[] = new Array<Consultant>();

    dropDownProjects: any;
    dropDownClient: any;
    dropDownResponsable: any;
    dropDownConsultant: any;

    dropDownCompanyGroups: any;
    selectedCompanyGroupsItems: DropDownList[] = new Array<DropDownList>();
    dropDownCompanyGroupsList: any = [];
    dropDownCompanyGroupsSettings = {};

    itemsPerPage: number[] = [5, 10, 50, 100];
    totalItems: number = 0;
    currentPage: number = 1;

    dropDownListProjectStatus: DropDownList[] = new Array<DropDownList>();
    selectedProjectStatus: DropDownList[] = new Array<DropDownList>();
    dropDownProjectStatusSettings = {};


  constructor(
    private projectsFinancial: ProjectFinancialService,
    private companyService: CompanyService,
    private json2csvService: Json2csvService,
    private localStorage: LocalStorage,
    private excellenceCentersService: ExcellenceCentersService
  ) { }

  async ngOnInit() {
      this.loading = true;
      await this.populateExcellenceCenters();
      await this.populateProjects();
      await this.populateCompanies();
      await this.populateResponsables();
      await this.populateConsultants();
      this.populateProjectStatus();
      this.projectsSearch = {};
      this.dropDownCompanyGroupsSettings = this.commonHelper.getDropDownSettings(false, 'Grupo de empresa', false, '', '', true,null, '')
      this.dropDownProjectStatusSettings = this.commonHelper.getDropDownSettings(true, 'Status do Projeto', false, '', '', false, null, '');
      this.retrieve();

      this.closeLoad();
  }

  persist(){
    let project={
      selectProjects:this.dropDownProjects.selectedItems,
      selectCompanies:this.dropDownClient.selectedItems,
      selectResponsibles: this.dropDownResponsable.selectedItems,
      selectConsultants : this.dropDownConsultant.selectedItems,
      status: this.selectedProjectStatus
    }
    this.localStorage.persist('project',project);
  }

  retrieve(){
    let project = this.localStorage.retrieve('project');
    if(project){
      this.dropDownProjects.selectedItems = project.selectProjects,
      this.dropDownClient.selectedItems = project.selectCompanies,
      this.dropDownResponsable.selectedItems = project.selectResponsibles,
      this.dropDownConsultant.selectedItems = project.selectConsultants,
      this.selectedProjectStatus = project.status || []
    }
  }

  async search(pg?: number, toexport?: boolean) {
    let limit, skip;
    this.loading = true;
    this.currentPage = pg ? pg : 1;
    this.findResults.skip = (pg - 1) * this.findResults.limit;

    if(toexport) {
        limit = this.findResults.limit;
        skip = this.findResults.skip;
        delete this.findResults.skip;
        delete this.findResults.limit
    }

    this.projectsSearch.projects = [];
    this.projectsSearch.companyGroups = [];
    this.projectsSearch.clients = [];
    this.projectsSearch.responsibles = [];
    this.projectsSearch.projectHash = [];
    this.projectsSearch.consultants = [];
    this.projectsSearch.projectActive = [];
    this.projectsSearch.excellenceCenters = []
    this.projectsSearch.findResults = this.findResults;

    for (let exc of this.selectedExcellenceCentersItems)
        this.projectsSearch.excellenceCenters.push(exc.id)

    for (let pro of this.dropDownProjects.selectedItems)
      this.projectsSearch.projects.push(pro.id);

    for (let cli of this.dropDownClient.selectedItems)
      this.projectsSearch.clients.push(cli.id);

    for (let com of this.selectedCompanyGroupsItems)
      this.projectsSearch.companyGroups.push(com.id);

    for (let res of this.dropDownResponsable.selectedItems)
      this.projectsSearch.responsibles.push(res.id);

    for (let con of this.dropDownConsultant.selectedItems)
      this.projectsSearch.consultants.push(con.id);

    for (let status of this.selectedProjectStatus)
      this.projectsSearch.projectActive.push(status.id);

    this.findResults = await this.projectsFinancial.getFilterProjectsFinancial(this.projectsSearch);

    this.projectsShow = this.findResults.anotherModel;
    this.populateListProjectsConsultants();

    this.findResults.anotherModel = {};
    this.totalItems = this.findResults.totalItems == null ? this.totalItems : this.findResults.totalItems;

    if(toexport) {
        this.findResults.skip = skip;
        this.findResults.limit = limit;
    }

    this.persist();
    this.loading = false;

  }

  async populateCompanies() {
    this.companies = await this.projectsFinancial.getAllCompany(false);
    this.dropDownClient = await this.projectsFinancial.createPropertyObjDropDown(this.companies, false, "Cliente", "clientes",['group'],'group');
    this.dropDownClient.dropDownList.forEach(item => item.group =  this.commonHelper.transcriptDivisionGroup(item.group));

    this.dropDownCompanyGroups = await this.companyService.getAllCompanyGroups()

    await this.dropDownCompanyGroups.forEach(item => {
      this.dropDownCompanyGroupsList.push({id: item._id, itemName: item.name})
    });
  }

  async populateExcellenceCenters() {
    const center = await this.excellenceCentersService.getAll();
    this.excellenceCenters = center.filter(ec => Number(ec.type) == 1);
    const dropDown = await this.projectsFinancial.createPropertyObjDropDown(this.excellenceCenters, false, "Centro de excelência", "Centros de excelência");
    this.dropDownListExcellenceCenters = dropDown.dropDownList
    this.dropDownExcellenceCentersSettings = dropDown.dropDownSettings
  }

  async populateProjects() {
    this.projects = await this.projectsFinancial.getAllProjectsFinancial();
    this.dropDownProjects = await this.projectsFinancial.createPropertyObjDropDown(this.projects, false, "Projetos", "projetos");
  }

  async populateResponsables() {
    this.responsibles = await this.projectsFinancial.getAllResponsable()
    this.dropDownResponsable = await this.projectsFinancial.createPropertyObjDropDown(this.responsibles, true, "Responsável", "responsáveis");
  }

  async populateConsultants() {
    this.consultantsLoad = await this.projectsFinancial.getAllConsultants();
    this.dropDownConsultant = await this.projectsFinancial.createPropertyObjDropDown(this.consultantsLoad, false, "Consultores", "consultores");
  }

  populateProjectStatus() {
    this.dropDownListProjectStatus = [
      {
        id: 'true',
        itemName: 'Ativo',
      },
      {
        id: 'false',
        itemName: 'Inativo',
      }
    ]
  }

  closeLoad() {
      if ( this.companies.length > 0 && this.responsibles.length > 0 && this.consultantsLoad.length > 0) {
            this.loading = false;
            this.search(1);
        }
  }

  async export() {
    await this.search(1, true);
    this.json2csvService.export(
        this.projectsShow.map(pjShow => {
          return {
              ID: pjShow._id,
              Projeto: pjShow.name,
              Grupo: pjShow.companyGroup ? pjShow.companyGroup.name : "",
              Cliente: pjShow.company.name,
              HashTrack: pjShow.hashTrack[0]['export']?pjShow.hashTrack[0]['export']:"",
              Consultores: pjShow.consultants.length > 0 ? pjShow.consultants[0]['export'] : "",
              Responsável: pjShow.userResponsable.name,
              SAP: pjShow.sapProjectId,
              Tipo: pjShow.projectExpense ? "Despesa" : "Custo",
              Ativo: pjShow.active ? "Sim" : "Não",
              "Centro de Excelência": pjShow.excellenceCenters ? pjShow.excellenceCenters.map((excellenceCenter) => excellenceCenter.name).join(' | ') : '-'
          };
      }),
      `Projetos - ${new Date().toLocaleDateString('pt-br')}`
    );
  }

  populateListProjectsConsultants() {
    this.projectsShow.forEach(pj => {
        pj.hashTrack[0] = this.populateValueList(pj.hashTrack);
        pj.consultants[0] = this.populateValueList(pj.consultants);
    });
  }

  populateValueList(objArr): any {
      if (objArr.length > 0) {
        var valueList = new Array();
        objArr.forEach(elem => {
            valueList.push(elem.name);
        });
        objArr[0]['export'] = valueList.join(" | ");
        objArr[0]['tooltip'] = valueList;
        objArr[0].name += valueList.length > 0 ? " | ..." : "";
        objArr[0]['expand'] = false;
        return objArr[0];
    } else {
        return objArr;
    }
  }

  collapse(idToggle) {
    idToggle['expand'] = !idToggle['expand'];
  }

  isActive(active: boolean) {
    return active ? "badge-success" : "badge-danger";
  }

  isActiveText(active: boolean) {
    return active ? "Ativo" : "Inativo";
  }
}



// WEBPACK FOOTER //
// ./src/app/views/projects/projects.component.ts